module.exports = __webpack_public_path__ + "img/icon-hardware.8452e2dd.svg";